import { Link, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type AdminSummary } from '../../api.ts';

export function useAdminSession() {
  return useQuery({
    queryKey: ['admin', 'session'],
    queryFn: () => api.get<{ admin: AdminSummary | null }>('/api/admin/session'),
  });
}

export function AdminChrome({ admin }: { admin: AdminSummary }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const signOut = useMutation({
    mutationFn: () => api.del('/api/admin/session'),
    onSuccess: () => { queryClient.clear(); navigate('/admin/signin'); },
  });

  return (
    <header className="masthead">
      <h1>
        <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
          SEED Scholarship — review
        </Link>
      </h1>
      {/* Only an administrator sees these; a reviewer cannot use those routes. */}
      {admin.canConfigure && <Link to="/admin/campaigns" className="tag">Email</Link>}
      {admin.canConfigure && <Link to="/admin/settings" className="tag">Settings</Link>}
      <span className="spacer" />
      <span className="who">{admin.name || admin.email} · {admin.role}</span>
      <button className="quiet" onClick={() => signOut.mutate()}>Sign out</button>
    </header>
  );
}
